import React from 'react'

function SearchIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22">
      <path
        fill="#24206B"
        fillRule="evenodd"
        d="M9.223 2.095c-3.906 0-7.083 3.177-7.083 7.082s3.177 7.081 7.083 7.081 7.082-3.176 7.082-7.081c0-3.905-3.176-7.082-7.082-7.082zm0 16.176a9.041 9.041 0 01-6.432-2.663A9.034 9.034 0 01.126 9.177c0-2.43.947-4.713 2.665-6.431A9.041 9.041 0 019.223.082c2.43 0 4.714.946 6.432 2.664a9.034 9.034 0 012.664 6.43c0 2.43-.946 4.714-2.664 6.432a9.036 9.036 0 01-6.432 2.663zm-4.245-8.07c-.555 0-1.005-.45-1.005-1.007a5.238 5.238 0 015.233-5.233 1.006 1.006 0 010 2.013 3.225 3.225 0 00-3.222 3.22c0 .556-.45 1.007-1.006 1.007zm15.848 11.66c-.26 0-.516-.1-.713-.296l-3.344-3.345a1.005 1.005 0 111.422-1.423l3.344 3.345a1.004 1.004 0 01-.71 1.718z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default SearchIcon



// WEBPACK FOOTER //
// ./src/app/elements/Icons/SearchIcon.js